import {
    BaseBoxShapeUtil,
    HTMLContainer,
    RecordProps,
    T,
    TLBaseShape,
    stopEventPropagation,
    TLResizeHandle,
} from 'tldraw'
import {FetchImagesSubTaskProcess, TaskStatusType} from "../types/taskFlow.types";
import CircularProgress from "@mui/material/CircularProgress";
import FilterIcon from '@mui/icons-material/Filter';
import { useDispatch } from 'react-redux';
import {setCurrentDialogImageInfo, setSelectCanvasImage} from '../store/taskSlice';
import { store } from '../store';



type IMyEditableShape = TLBaseShape<
    'hover-tool-bar',
    {
        text: string,
        status: string,
        h: number,
        w: number,
        loading: boolean
        taskId: number
        content: string
    }
>

export class HoverToolBarUtil extends BaseBoxShapeUtil<IMyEditableShape> {
    static override type = 'hover-tool-bar' as const
    static override props: RecordProps<IMyEditableShape> = {
        text: T.string,
        status: T.string,
        w: T.number,
        h: T.number,
        loading: T.boolean,
        taskId: T.number,
        content: T.string
    }


    getDefaultProps(): IMyEditableShape['props'] {
        return {
            text: '对【蛇元素】和【新中式】进行发散联想',
            status: '待确认',
            w: 260,
            h: 40,
            loading: true,
            taskId: 0,
            content: ''
        }
    }

    // 禁用调整大小功能
    override canResize = (_shape: IMyEditableShape) => {
        return false
    }

    // 隐藏调整大小的控制点
    override hideResizeHandles = (_shape: IMyEditableShape): boolean => {
        return true
    }

    // [2]
    component(shape: IMyEditableShape) {
        // [a]
        const isEditing = this.editor.getEditingShapeId() === shape.id

        //const dispatch = useDispatch();

        const content = JSON.parse(shape.props.content) as FetchImagesSubTaskProcess

        const taskId = shape.props.taskId

        const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''

        return (
                <HTMLContainer
                    id={shape.id}
                    // [b]
                    style={{
                        pointerEvents: 'all',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        backgroundColor: 'white',
                        padding: 8,
                        borderRadius: 10,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        justifyContent: 'center'
                    }}                     onPointerDown={e => {
                        e.stopPropagation();
                        store.dispatch(setCurrentDialogImageInfo({
                            description: content?.description ?? '',
                            note: content?.note ?? '',
                            groupId: content?.groupId ?? 0,
                            tags: content?.tags ?? [],
                            url: content?.url ? `${temporary_url}${content?.url}` : '',
                            taskId
                        }));
                    }}>
                        <FilterIcon/>
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: 8,
                        borderRadius: 10,
                        height: '100%',
                        backgroundColor: 'white',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        marginLeft: 6,
                    }}
                         onPointerDown={e => {
                             e.stopPropagation();
                             store.dispatch(setSelectCanvasImage([content?.url]))
                         }}
                    >添加到对话 <span style={{color: '#999999',
                        border: "1px solid #999999",
                        padding: "1px 3px 2px 3px", marginLeft: 6}}>Enter</span></div>
                </HTMLContainer>
        )
    }

    indicator(shape: IMyEditableShape) {
        // 返回固定大小的indicator
        return <rect width={shape.props.w} height={shape.props.h} />
    }
}